module.exports = __webpack_public_path__ + "img/tester-role04.c6c7ba75.jpg";